// Toggle filters on devices below the large breakpoint
$('.filter-toggle').click(function(event) {
    var filterOptions = $('.filter-form');
    var break_point = 992;
    var browser_width = window.innerWidth;

    if (browser_width < break_point) {
        event.preventDefault();
        filterOptions.toggleClass('__active');
        $(this).toggleClass('__active');
    }

    if (filterOptions.hasClass('__active')) {
        filterOptions.slideDown();
    }

    else {
        filterOptions.slideUp();
    }
})